<style scoped lang="scss">
    @import "../../../styles/var";

    .fullscreen {
        background-color: #f0f0f0;
        position: fixed;
        @extend %trbl;
    }

    .close {
        i {
            font-size: 30px;
        }

        justify-content: flex-end;
        height: 40px;
        box-shadow: 0 -1px 0 0 rgba(0, 0, 0, 0.1);
    }

    .lpart {
        width: 320px;
    }

    .rpart {
        position: relative;
        flex: 1;
        display: flex;

        .local_div {
            position: relative;
        }

        .remote_div {
            position: relative;
        }
    }

    .info {
        height: 120px;
    }

    .chart {
        background-color: #f5faff;
    }

    .btns {
        height: 200px;

        ul {
            flex-wrap: wrap;

            li {
                width: 70px;
            }
        }
    }
</style>
<template>
    <div class="fullscreen flex column">
        <div class="close flex0 bg_fff pr15 flex aic">
            <i class="el-icon-close pointer" @click="$router.back()"></i>
        </div>
        <div class="main flex1 mt15 flex">
            <div class="lpart flex0 flex column">
                <div class="info bg_fff flex0 pl15 pr15 pt10 pb10">
                    <h3 class="flex fs16">
                        <span class="flex1">{{info.consulterName}} {{info.consulterIdcard|getSexFromIdCardFilter}} {{info.consulterIdcard|getAgeFromIdCardFilter}}</span>
                        <span>{{info.acceptHosName}}</span>
                    </h3>
                    <p class="flex fs12 mt10">
                        <span class="color_666">{{info.acceptDeptName}}-{{info.acceptDocName}}</span>
                        <span class="color_666 ml15">{{info.hopeTime}}</span>
                    </p>
                    <div class="flex aic mt10" style="justify-content: space-between">
                        <div class="flex0 flex column aic">
                            <img src="../../../assets/icon/online/候诊中.png" alt=""/>
                            <p class="fs12 color_main">候诊中</p>
                        </div>
                    </div>
                </div>
                <concul-message-box class="flex1 mt15" ref="msgBox"></concul-message-box>
                <send-msg-box-simple @send="send" ref="sendBox"></send-msg-box-simple>
                <div class="btns bg_fff flex0 mt15">
                    <ul class="flex pl20 pr20 pt20">
                        <li
                                v-for="(item, index) in btns"
                                :key="index"
                                class="flex pointer column aic pt10 pb10"
                                @click="btnClick(item.name)"
                        >
                            <img :src="item.icon" alt="" height="20"/>
                            <span class="fs12 color_333">{{ item.name }}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="rpart pl15 pr15" ref="videoDiv">
                <div class="local_div" :style="localStyle">
                    <template v-for="user in list">
                        <full-video-page :info="user" :style="localStyle" v-if="user.bigScreen" :key="user.deviceId"
                                         :ref="user.deviceId"></full-video-page>
                    </template>
                </div>
                <div class="remote_div pl15" :style="remoteStyle">
                    <happy-scroll size="5"
                                  color="rgba(0,0,0,0.5)">
                        <div>
                            <template v-for="user in list">
                                <div style="height: 200px;width: 95%;position: relative;" class="mb20">
                                    <full-video-page :info="user" v-if="!user.bigScreen" :style="{height: '200px',width:remoteStyle.width}"
                                                     :ref="user.deviceId" @big="bigScreen"></full-video-page>
                                </div>
                            </template>
                        </div>
                    </happy-scroll>
                </div>

                <full-video-audio v-for="(audio,index) in audio_list" :key="index" :info="audio"></full-video-audio>
            </div>
        </div>
        <msg_load ref="ImgLoad" v-show="false" @succ="getMsgList"></msg_load>
        <consultation-bank-dialog ref="whiteBank"></consultation-bank-dialog>
        <share-dialog ref="shareRoomDialog"></share-dialog>
        <disease-info ref="diseaseInfo" :info="detail"></disease-info>
    </div>
</template>

<script>
  import SendMsgBoxSimple from "../../../components/common/send-msg-box-simple";
  import {VIDEO_COMMON_BTNS} from "../../../lib/config";
  import {fullVideoMixin} from "../../../lib/video/fullVideoTencentMinxin";
  import msg_load from "../../../components/consultation/msg-load"
  import FullVideoPage from "../../../components/consultation/full-video-page-tencnet"
  import FullVideoAudio from "../../../components/consultation/full-video-audio"
  import ConsultationBankDialog from "../../../components/consultation/bank-dialog"
  import {getAgeFromIdCardFilter, getSexFromIdCardFilter} from "../../../lib/filters";
  import DisMessageBox from "../../../components/dis/dis-message-box";
  import {isEmpty} from "../../../lib/utils";
  import {consultationService} from "../../../lib/service/consultation";
  import ConculMessageBox from "../../../components/consultation/concul-message-box";
  import ShareDialog from "../../../components/common/share-room-dialog"
  import DiseaseInfo from "../../../components/consultation/disease-info-dialog"
  import {tokenCache} from "../../../lib/cache/Token";
  import {MessageBox} from 'element-ui';

  export default {
    name: "fullscreen",
    filters: {getAgeFromIdCardFilter, getSexFromIdCardFilter},
    components: {
      ConculMessageBox,
      DisMessageBox,
      SendMsgBoxSimple,
      FullVideoPage,
      FullVideoAudio,
      msg_load,
      ConsultationBankDialog,
      ShareDialog,
      DiseaseInfo
    },
    mixins: [fullVideoMixin],
    data() {
      return {
        data: {},
        list: [],
        audio_list: [],
        Centerinfo: null,
        msgs: [],
        msgTimer: null,
        localStyle: {},
        remoteStyle: {},
        detail:{}
      };
    },
    computed: {
      info() {
        return this.data.consultGroup || {};
      },
      btns() {
        return VIDEO_COMMON_BTNS;
      }
    },
    created() {
      this.query = this.$route.query;
      this.initStyle();
    },
    async mounted() {
      this.init();
    },
    beforeDestroy() {
      this.LeaveRoom_();
      this.clear();
      if( window.localPub||window.localSharePub){
        this.LeaveRoom_();
        window.localPub = window.localSharePub = false
      }
    },
    watch: {
      videos() {
        this.list = [...this.videos];
        if (this.Centerinfo) {
          this.bigScreen(this.Centerinfo)
        }
      },
      audios() {
        this.audio_list = [...this.audios];
      }
    },
    methods: {
      initStyle() {
        let width = document.body.clientWidth - 320;
        let height = document.body.clientHeight - 70;
        let w1 = (width - 30) * 0.7 - 15;
        let w2 = (width - 30) * 0.3 + 15;
        this.localStyle = {
          width: `${w1}px`,
          height: `${height}px`,
        }
        this.remoteStyle = {
          width: `${w2}px`,
          height: `${height}px`,
        }
      },
      bigScreen(info) {
        this.Centerinfo = info;
        console.log('info',info)
        this.list.forEach(r => {
          if (info.deviceId === r.deviceId) {
            this.$set(r, 'bigScreen', true);
          } else {
            this.$set(r, 'bigScreen', false);
          }
        })
      },
      async init() {
        const {query} = this;
        if (isEmpty(this.data)) this.data = await consultationService.detail(query.id);
        await this.getMsgList();
        const {room} = await consultationService.intovideo(query.id);
        if (room.roomNo) this.query.room = room.roomNo;
        await this.getTencentSign(this.joinInfo.id)
      },
      async send(content) {
        await consultationService.reply({
          consultId: this.query.id,
          replyContent: content,
          replyContentType: 'TEXT'
        })
        this.$refs.sendBox.clear();
      },
      clear() {
        if (this.msgTimer) {
          clearTimeout(this.msgTimer);
          this.msgTimer = null;
        }
      },
      async getMsgList() {
        await this.$refs.msgBox.getMsg(this.query.id);
        this.clear();
        this.msgTimer = setTimeout(() => {
          this.getMsgList();
        }, 5000);
      },
      btnClick(name) {
        if (name == '桌面分享') {
          /*const selfUser = this.gettee3getSelfUser();
          let idx = this.videos.findIndex(r => r.userId === selfUser.id)
          let device;
          if (idx >= 0) {
            device = this.$refs[this.videos[idx].deviceId][0] || {}
            device.screenClick();
          } else {
            this.$message.error('暂未找到您的共享设备。')
          }*/
          this.startShare()
        }
        if (name == '挂断') {
          this.LeaveRoom_();
          setTimeout(() => {
            this.$router.go(-1)
          }, 3000)
        }

        if (name == '图片') {
          this.$refs.ImgLoad.start(this.query.id);
        }

        if (name == '文件传输') {
          this.$refs.ImgLoad.startFile(this.query.id);
        }

        if (name == '白板') {
          this.$refs['whiteBank'].show();
        }

        if (name === '邀请讨论') {
          //this.$message.error('功能暂未开放');
          this.$refs.shareRoomDialog.show(this.query.id);
        }
        if(name === '病情资料'){
          this.detail = this.data
          this.$refs.diseaseInfo.show(this.query.id);
        }

      }
    },
    beforeRouteEnter(to, from, next) {
      const token = tokenCache.get();
      if (!!token) {
        next();
      } else {
        MessageBox.confirm('您还未登陆,请先登陆!', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          next({
            path: '/login',
            query: {
              ...to.query,
              fullVideo: true
            }
          });
        }).catch(() => {
          next(false);
        });
      }
    }
  };
</script>
